// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import {Autoplay} from 'swiper/modules';

export function testimonialBlockAwards() {
    const awards = document.querySelectorAll(`[data-component="testimonials-awards"]`);

    if (!awards.length) return;

    [...awards].forEach((cmp) => {
        const carousel = cmp.querySelector(`[data-carousel="awards-block"]`);
        const slidesCount = cmp.querySelectorAll(`[data-role="swiper-slide"]`).length;
        const isAutoplayEnabled = cmp.dataset.autoplay.match(/yes/i);

        if (slidesCount >= 2) {
            // Define base modules (like Navigation, Pagination)
            let swiperModules = [];

            // Conditionally add Autoplay if the class exists
            if (isAutoplayEnabled) {
                swiperModules.push(Autoplay);
            }

            const swiper = new Swiper(carousel, {
                modules: swiperModules,
                autoplay: isAutoplayEnabled
                    ? {
                          delay: 5000,
                      }
                    : false,
                slidesPerView: 1,
                loop: true,
                a11y: {
                    slideRole: '',
                },
                on: {
                    slideChange: function () {
                        function updateButtonColor(selector, color) {
                            const buttons = carousel.querySelectorAll(selector);
                            if (buttons) {
                                buttons.forEach((button) => {
                                    button.style.fill = color;
                                });
                            }
                        }

                        const isFirstSlide = this.activeIndex === 0 && !this.params.loop;
                        const isLastSlide = this.activeIndex === this.slides.length - 1 && !swiper.params.loop;

                        updateButtonColor('.swiper-button-prev svg path', isFirstSlide ? '#b9bdc8' : '#060D32');
                        updateButtonColor('.swiper-button-next svg path', isLastSlide ? '#b9bdc8' : '#060D32');
                    },
                },
            });

            const swiperPrev = cmp.querySelectorAll('.swiper-button-prev');
            const swiperNext = cmp.querySelectorAll('.swiper-button-next');

            const prevButtonPaths = cmp.querySelectorAll('.swiper-button-prev svg path');
            let color = swiper.activeIndex === 0 && !swiper.params.loop ? '#b9bdc8' : '#ffffff';

            prevButtonPaths.forEach((path) => {
                path.style.fill = color;
            });

            swiperPrev.forEach((prev) => {
                prev.addEventListener('click', () => {
                    swiper.slidePrev();
                });
            });

            swiperNext.forEach((next) => {
                next.addEventListener('click', () => {
                    swiper.slideNext();
                });
            });

            swiper.on('slideChange', (e) => {
                color = e.activeIndex === 0 && !e.params.loop ? '#b9bdc8' : '#ffffff';

                prevButtonPaths.forEach((path) => {
                    path.style.fill = color;
                });
            });
        } else {
            const swiperPrev = cmp.querySelectorAll('.swiper-button-prev');
            const swiperNext = cmp.querySelectorAll('.swiper-button-next');

            swiperPrev.forEach((prev) => {
                prev.style.display = 'none';
            });

            swiperNext.forEach((next) => {
                next.style.display = 'none';
            });
        }
    });
}
